.a8{overflow:hidden;}